import { API, graphqlOperation } from "aws-amplify";
import React, { useContext, useEffect, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import toast from "react-hot-toast";
// import moment from "moment";
import { Button, Col, Modal, Row } from "react-bootstrap";

import { retryDwollaCustomer, createDwollaUnverifiedCustomer } from "../../../graphql/mutations";
import {
  getPlaidAccessToken,
  getPlaidAccounts,
  getDwollaProcessorToken,
  getPlaidInstitution,
} from "../../../graphql/queries";
import { Context } from "../../../Utility/ContextManager";
import { getId } from "../../../Utility";
import envFile from "../../../envFile";
import UserInfoForm from "./UserInfoForm";
import { createRecordTB, fetchAllBankAccounts, updateRecordTB, updateTenantFn } from "../../../Utility/ApiService";
import { sendHubspotEmail } from "../../../graphql/queries";

function AddBankAccount({
  loading,
  setLoading,
  getAllBankAccounts,
  isFromDashboard = false,
  showUserInfoModal,
  setShowUserInfoModal,
}) {
  const { user, setUser, plaidToken, bankAccounts } = useContext(Context);

  const [nick_name, setNickName] = useState("");
  const [show, setShow] = useState(false);
  const [check, setCheck] = useState(false);
  const [isNoticeVisible, setIsNoticeVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 570);

  const { open } = usePlaidLink({
    token: plaidToken,
    onSuccess: async (public_token, metadata) => {
      //on manual verfication(used routing/account number instead of username/password) we will send the user a hubspot email
      if (
        metadata?.account?.verification_status === "pending_manual_verification" ||
        metadata?.account?.verification_status === "manually_verified"
      ) {
        await API.graphql(
          graphqlOperation(sendHubspotEmail, {
            id: user?.id,
            role: "Tenant",
            code: "ADDBANKACCOUNT",
            data: JSON.stringify({
              name: `${user?.first_name + " " + user?.last_name}`,
              bank: metadata?.account?.name || "",
            }),
          })
        );
      }
      addBankAccount(metadata);
    },
  });

  const addBankAccount = async (metadata) => {
    try {
      const { public_token, account } = metadata;
      setLoading(true);
      const res = await API.graphql(
        graphqlOperation(getPlaidAccessToken, {
          publicToken: public_token,
        })
      );
      const AccessToken = res.data.getPlaidAccessToken.response;
      let accountObj = {};
      const tmp_bank = JSON.parse(localStorage.getItem("tmp_bank") || "{}");
      const bankAccounts = await fetchAllBankAccounts({ tenant_id: user?.id }); // do not changes this line
      const oldDefaultAccount = bankAccounts.find((item) => item.default_bank_account === 1);
      if (account?.verification_status === "pending_manual_verification") {
        accountObj = {
          id: getId(),
          account_number: account?.mask,
          active: 1,
          bank_name: "",
          // created_at: new Date(),
          default_bank_account: tmp_bank.check ? 1 : 0,
          nick_name: tmp_bank.nick_name,
          institution_id: "",
          routing_number: "",
          tenant_id: user.id,
          account_id: account?.id,
          dwolla_funding_id: "",
          status: account?.verification_status,
          plaid_access_token: AccessToken,
        };
      } else {
        let resData = await API.graphql(
          graphqlOperation(getPlaidAccounts, {
            accessToken: AccessToken,
          })
        );
        resData = JSON.parse(resData.data.getPlaidAccounts.response);
        const AccountId = resData.accounts[0].account_id;
        const AccountName = resData.accounts[0].name;
        // const AccountType = resData.accounts[0].type;
        const InstituteId = resData.item.institution_id;
        const MaskNumber = resData.accounts[0].mask;
        const Routing_number = resData.numbers.ach[0].routing;

        let resgetPlaidInstitution = null;
        if (InstituteId) {
          resgetPlaidInstitution = await API.graphql(
            graphqlOperation(getPlaidInstitution, {
              institutionId: InstituteId,
            })
          );
        }

        let parsedResponse;

        try {
          parsedResponse = JSON.parse(resgetPlaidInstitution?.data?.getPlaidInstitution?.response);
        } catch (e) {
          console.error("Failed to parse response as JSON", e);
          // Optionally set resData to a default value or handle the error in a specific way
          parsedResponse = {}; // Setting to an empty object or another suitable default
          // You might also want to return or throw the error to halt further processing
        }

        const bank_name = parsedResponse?.institution?.name;
        // const bank_name = await getBankName(InstituteId);
        /*
        if (!bank_name) {
          toast.error("Something went wrong please try later");
          return;
        }
        */
        const customerUrl = `${envFile.DwOLLA_API_URL}/customers/${user?.dwolla_customer_id}`;
        const getFundingId = await API.graphql(
          graphqlOperation(getDwollaProcessorToken, {
            accessToken: AccessToken,
            accountId: AccountId,
            bankName: AccountName,
            customerUrl,
          })
        );
        if (
          getFundingId.data.getDwollaProcessorToken.status !== 200 &&
          getFundingId.data.getDwollaProcessorToken.status !== 201
        ) {
          // toast.error(getFundingId.data.getDwollaProcessorToken.response.split(":")[0]);
          toast.error("Bank already exists");
          setLoading(false);
          return;
        }

        const fundingId = getFundingId.data.getDwollaProcessorToken.response;

        accountObj = {
          id: getId(),
          account_number: MaskNumber,
          active: 1,
          bank_name: bank_name,
          // created_at: new Date(),
          default_bank_account: tmp_bank.check ? 1 : 0,
          nick_name: tmp_bank.nick_name,
          institution_id: InstituteId,
          routing_number: Routing_number,
          tenant_id: user.id,
          account_id: AccountId,
          dwolla_funding_id: fundingId,
          status: "verified",
          plaid_access_token: AccessToken,
        };
      }

      await createRecordTB("TenantBankAccount", accountObj);

      // do not changes this line
      if (oldDefaultAccount) {
        await updateRecordTB("TenantBankAccount", {
          id: oldDefaultAccount.id,
          default_bank_account: 0,
        });
      }

      localStorage.removeItem("tmp_bank");
      setNickName("");
      setCheck(false);
      getAllBankAccounts();
      setLoading(false);
    } catch (error) {
      console.log(error, "jhjhh");
      setLoading(false);
    }
  };

  const updateUserInfo = async (dwolla_customer_id) => {
    const obj = {
      id: user.id,
      dwolla_customer_id: dwolla_customer_id,
      status: "UNVERIFIED",
    };
    setLoading(true);
    await updateTenantFn(obj).then((res) => {
      setShowUserInfoModal(false);
      setUser(res);
      setLoading(false);
    });
  };

  useEffect(() => {
    //if localstorage has dwolla_customer_id then set show as true
    if (localStorage?.getItem("dwolla_customer_id")) {
      setShow(true);
      localStorage?.removeItem("dwolla_customer_id");
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 570);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const UpdateOrCreateDwollaAccount = async (userInfo) => {
    setLoading(true);
    let payload = {
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      email: userInfo.email,
      //ipAddress: await getPublicIpv4(),
    };

    if (user?.status === "REVERIFICATION") {
      payload["customerId"] = user?.dwolla_customer_id;
    }

    const getCustomerId = await API.graphql(
      graphqlOperation(user?.status === "REVERIFICATION" ? retryDwollaCustomer : createDwollaUnverifiedCustomer, {
        ...payload,
      })
    );

    if (user?.status !== "REVERIFICATION") {
      if (getCustomerId.data.createDwollaUnverifiedCustomer.status === 500) {
        setLoading(false);
        toast.error(getCustomerId.data.createDwollaUnverifiedCustomer.response);
        return;
      }
      let customerId = getCustomerId.data.createDwollaUnverifiedCustomer.response;
      localStorage?.setItem("dwolla_customer_id", true);
      await updateUserInfo(customerId);
    } else {
      localStorage?.setItem("dwolla_customer_id", true);
      await updateUserInfo(user?.dwolla_customer_id);
    }
    setLoading(false);
    window.location.reload();
  };

  return (
    <React.Fragment>
      <UserInfoForm
        showUserInfoModal={showUserInfoModal}
        handleClose={() => {
          setLoading(false);
          setShowUserInfoModal(false);
        }}
        UpdateOrCreateDwollaAccount={UpdateOrCreateDwollaAccount}
        loading={loading}
      />

      <div className={isFromDashboard ? "" : "card bankCard"}>
        <a
          href="#"
          data-cy="add-bank-account-card"
          className={`${
            user?.status !== "VERIFIED" &&
            user?.status !== "UNVERIFIED" &&
            user?.status !== "ACTIVATED" &&
            user?.dwolla_customer_id &&
            "text-muted cursor-notAllowed"
          } add-account`}
          onClick={() => {
            if (bankAccounts.length >= 3) {
              setIsNoticeVisible(true);
            } else {
              if (user?.dwolla_customer_id) {
                if (
                  user?.status === "VERIFIED" ||
                  user?.status === "UNVERIFIED" ||
                  user?.status === "ACTIVATED" ||
                  !user?.status
                ) {
                  setShow(true);
                }
              } else {
                UpdateOrCreateDwollaAccount({
                  firstName: user?.first_name,
                  lastName: user?.last_name,
                  email: user?.email,
                });
              }
            }
          }}
        >
          {isFromDashboard ? (
            <button className="btn btn-inverse-2 w-100" style={{ height: "45px" }}>
              Add New Payment Method
            </button>
          ) : (
            /*<div className="card-body d-flex flex-column align-items-center justify-content-center h-100">
    <img src={require("../../../assets/images/add-icon.svg").default} alt="" />
    <span>Add Bank Account</span>
  </div>*/
            <div>
              <button className="btn btn-primary w-100">+ Add Bank Account</button>
            </div>
          )}
        </a>
      </div>
      <Modal
        className={`w-100 ${isMobile ? "modal-style-bottom" : "modal-style-1"}`}
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <div className="modal-header">
          <h4 className="modal-title">Add Bank Account</h4>
        </div>
        <Modal.Body>
          <div className="my-3">
            <label className="mb-2">Account Name / Nickname</label>
            <input
              value={nick_name}
              onChange={(e) => setNickName(e.target.value)}
              type="text"
              className="form-control"
              data-cy="account-name-text-field"
            />
          </div>
          <div className="form-switch d-flex d-md-flex justify-content-between justify-content-md-start mt-4">
            <div className="d-flex align-items-center mb-4">Make Default</div>
            <div>
              <input
                type="checkbox"
                hidden="hidden"
                id="SetupDefault"
                checked={check}
                onChange={() => setCheck(!check)}
              />
              <label className="switch" htmlFor="SetupDefault" />
            </div>
          </div>
          <Row>
            <Col xs={12} xl={6}>
              <Button className="w-100 me-3" variant="warning-inverse" onClick={() => setShow(false)}>
                Cancel
              </Button>
            </Col>
            <Col xs={12} xl={6}>
              <Button
                className="w-100 mt-4 mt-md-0"
                variant="primary"
                data-cy="add-bank-account-continue-button"
                onClick={() => {
                  setShow(false);
                  localStorage.setItem("tmp_bank", JSON.stringify({ nick_name, check }));
                  open();
                }}
                disabled={!nick_name}
              >
                Continue
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal className="modal-style-1 w-100" centered show={isNoticeVisible} onHide={() => setIsNoticeVisible(false)}>
        <Modal.Body>
          <div className="form-switch d-flex">
            <div className="d-flex align-items-center" style={{ marginBottom: 30 }}>
              You cannot add more than three bank accounts.
            </div>
          </div>

          <Row>
            <Col xs={12}>
              <Button className="w-100" variant="primary" onClick={() => setIsNoticeVisible(false)}>
                Got it
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default AddBankAccount;
